import { useMemo } from "react";
// F3, H4: cấu hình tập trung cho paper trade. Dễ đổi qua prop.
export function usePaperTradeConfig(options = {}) {
    const { feeRate = 0, slippageBps = 0, defaultQty = 1, sizingMode = "fixed", riskPercent = 1, initialEquity = 10000, symbol, } = options;
    return useMemo(() => ({
        feeRate: feeRate >= 0 ? feeRate : 0,
        slippageBps: slippageBps >= 0 ? slippageBps : 0,
        defaultQty: defaultQty >= 1 ? defaultQty : 1,
        sizingMode,
        riskPercent: riskPercent > 0 ? riskPercent : 1,
        initialEquity: initialEquity > 0 ? initialEquity : 10000,
        symbol,
    }), [feeRate, slippageBps, defaultQty, sizingMode, riskPercent, initialEquity, symbol]);
}
